import colors from 'config/colors.module.scss';
import { DonationOutput } from 'gql/types';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.CollectedMlsChart');

export const getConfig = (donationData: DonationOutput[]) => {
  return {
    data: donationData,
    xField: 'donationDate',
    yField: 'actual',
    color: colors.pastelRed,
    xAxis: {
      title: {
        text: t('date'),
      },
    },
    yAxis: {
      title: {
        text: t('collectedMls'),
      },
      alias: t('totalCollectedMls'),
    },
  };
};
